<template>
  <a :href="block.content.url" class="block-cta" :class="block.content.style" target="_blank" rel="noopener">
    {{ block.content.text }}
  </a>
</template>

<script setup>
defineProps(['block'])
</script>

<style scoped>
.block-cta {
  display: inline-block;
  padding: 1.2rem 3rem;
  border: 1px solid var(--fg-50);
  font-size: 1.1rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  transition: background 200ms, color 200ms;
}

.block-cta.primary {
  background: var(--fg);
  color: var(--bg);
  border-color: var(--fg);
}

.block-cta:hover {
  background: var(--fg);
  color: var(--bg);
  border-color: var(--fg);
}
</style>
